module.exports = __webpack_public_path__ + "media/site/images/startups/skilldepository-cf98fb7f6518e0fd852a8eb6be6c8671.png";